module.exports = __webpack_public_path__ + "assets/img/3.a995bea0.webp";